var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.1665 9C17.8234 9 19.1665 7.65685 19.1665 6C19.1665 4.34315 17.8234 3 16.1665 3C14.5096 3 13.1665 4.34315 13.1665 6C13.1665 7.65685 14.5096 9 16.1665 9Z",
    fill: "#B8772A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1665 9C17.8234 9 19.1665 7.65685 19.1665 6C19.1665 4.34315 17.8234 3 16.1665 3C14.5096 3 13.1665 4.34315 13.1665 6C13.1665 7.65685 14.5096 9 16.1665 9Z",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1665 13H27.1665",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1665 13V18L6.1665 27",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1665 18L23.1665 21V27",
    stroke: "#B8772A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.733effb5b676efb91d7d1985e7c0759d.svg";
export { ForwardRef as ReactComponent };